<script>
export default {
  name: "Information",
};
</script>

<template>
  <br />
  <br />
  <h1>Information</h1>
  <h3>
    The quantity of iron, derived from magnetic tracers, is assessed by
    utilizing a lookup table (LUT) generated through the evaluation of the
    magnetic readout conducted by Sentimag (Endomagnetics Ltd., Cambridge, UK).
    Data pertaining to the following tracers is available: Sienna+®, Magtrace,
    and FerroTrace.
  </h3>
  <br />
  <h3>
    This calculator has been made available by the Magnetic Detection & Imaging
    group, under supervision of
    <a href="https://people.utwente.nl/l.alic">L. Alic.</a>
    If you utilize this calculator in any context, we kindly request that you
    acknowledge the website and the underlying data on which the calculator
    relies. ER Nieuwenhuis, et al.
    <a
      href="https://data.4tu.nl/articles/dataset/Look-up_table_LUT_for_Sentimag_and_Sienna_relation_between_magnetic_readout_counts_and_iron_content/15169674"
    >
      Look-up table (LUT) for Sentimag and Sienna, relation between magnetic
      readout (counts) and iron content. 4TU.ResearchData.</a
    >
    doi: 10.4121/15169674.v1Cite. RefWorks, BibTeX, Reference Manager, Endnote,
    DataCite, NLM, DC, CFF
  </h3>
  <br />
  <h3>
    S. Salamzadeh, et al.
    <a href="https://data.4tu.nl/datasets/2ad11693-4d07-488f-936e-a3d4d9430ae0"
      >Look-up table for assessment of iron content in Magtrace® samples based
      on Sentimag®. 4TU.ResearchData.</a
    >
    doi: 10.4121/2ad11693-4d07-488f-936e-a3d4d9430ae0.v1Cite RefWorks, BibTeX,
    Reference Manager, Endnote, DataCite, NLM, DC, CFF
  </h3>
  <br />
  <br />
  <h1>Publications using this calculator</h1>
  <br />
  <h3>
    ER Nieuwenhuis, er al.
    <a
      href="https://research.utwente.nl/en/publications/a-comprehensive-grading-system-for-a-magnetic-sentinel-lymph-node"
    >
      A Comprehensive Grading System for a Magnetic Sentinel Lymph Node Biopsy
      Procedure in Head and Neck Cancer Patients.</a
    >
    Cancers, 2022: 14(3).
    <a href="https://www.mdpi.com/2072-6694/14/3/678">
      https://doi.org/10.3390/cancers14030678.
    </a>
    Anke  LowMag paper
  </h3>
  <br />
  <h3>
    For inclusion in the list of publications, we kindly request you to contact
    us via email at Fe.calculator@utwente.nl.
  </h3>
  <br />
  <br />
</template>

<style scoped lang="less"></style>
